import React from "react";
import { Container } from "./styles";

const Announcement = () => {
  return <Container>10% off Use Code #ILOVEIT</Container>;
};

export default Announcement;
